import script from "./ObligationDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ObligationDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ObligationDialog.vue?vue&type=style&index=0&id=0b2bba39&lang=scss"

const __exports__ = script;

export default __exports__